import React from 'react';
import './style.scoped.scss';
import { ACCOUNT_NAVIGATION } from '../../../assets/constants/strings';
import SettingsTitle from '../SettingsTitle';
import UserInfo from '../../Dashboard/UserInfo';
import { HiDocumentText, HiOutlineChatAlt2, HiShare } from 'react-icons/hi';
import { MdSummarize } from 'react-icons/md';

const UsageStatus = ({ user }) => {
  const restrictions = user.userPlan.restrictions;
  // A restriction of 'Unlimited' (the Enterprise plan) has no meaningful "X out of Y" — show the
  // real count for the cycle plus an "Unlimited" pill instead of a full/empty progress bar.
  const isUnlimited = (metric) => restrictions[metric] === 'Unlimited';

  return (
    <div className='usage-frame' id='usage-frame'>
      <SettingsTitle title={ACCOUNT_NAVIGATION.USAGE.TITLE} />
      <p>
        The below usage stats are for the current billing cycle (from{' '}
        {user.userPlan.startedAt} -{' '}
        {user.userPlan.subscriptionName === 'Free'
          ? user.userPlan.endDate
          : user.userPlan.nextBilling}
        )
      </p>
      <UserInfo
        icon={<HiDocumentText />}
        title='Pages of Regulations Visited'
        percentage={(user.userUsage.pageviews / restrictions.pageviews) * 100}
        progressBarText={`${user.userUsage.pageviews} out of ${restrictions.pageviews}`}
        unlimited={isUnlimited('pageviews')}
        unlimitedText={`${user.userUsage.pageviews} viewed this cycle`}
        barColor='#123466'
        barId='visited'
        showBtn
      />
      <UserInfo
        iconId='pages-shared'
        icon={<HiShare />}
        title='Pages Shared'
        percentage={(user.userUsage.shares / restrictions.shares) * 100}
        progressBarText={`${user.userUsage.shares} out of ${restrictions.shares}`}
        unlimited={isUnlimited('shares')}
        unlimitedText={`${user.userUsage.shares} shared this cycle`}
        barColor='#ff7a00'
        barId='shared'
      />
      <UserInfo
        iconId='ai-queries'
        icon={<HiOutlineChatAlt2 />}
        title='AI Queries'
        percentage={(user.userUsage.queries / restrictions.queries) * 100}
        progressBarText={`${user.userUsage.queries} out of ${restrictions.queries}`}
        unlimited={isUnlimited('queries')}
        unlimitedText={`${user.userUsage.queries} run this cycle`}
        barColor='#00a587'
        barId='queries'
      />
      <UserInfo
        iconId='ai-summaries'
        icon={<MdSummarize />}
        title='AI Summaries'
        percentage={(user.userUsage.summaries / restrictions.summaries) * 100}
        progressBarText={`${user.userUsage.summaries} out of ${restrictions.summaries}`}
        unlimited={isUnlimited('summaries')}
        unlimitedText={`${user.userUsage.summaries} generated this cycle`}
        barColor='#00a587'
        barId='summary'
      />
    </div>
  );
};

export default UsageStatus;
